import { formatters } from '@utils/intl/dateTimeFormatters'
import { useFormatter } from '@api/useFormatter'
import { addCommasToNumber, GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Popover } from 'antd'
import React from 'react'

export function FourWeekAvgCellRenderer({ data }) {
  const weekday = formatters.LONG_DAY(data.date)
  const { sales_avg, sales_avg_days } = data

  const { formatVolume } = useFormatter()
  const formattedVolume = formatVolume(null, true)
  let exclusion = false
  const content = (
    <>
      <Texto category={'h6'} className={'mb-1'}>
        Previous 4 {weekday}s
      </Texto>
      <Horizontal justifyContent={'space-between'} className={'mb-1'}>
        <Texto weight={'bold'}>Date</Texto>
        <Texto weight={'bold'} textTransform={'capitalize'}>
          Sales ({formattedVolume}s)
        </Texto>
      </Horizontal>
      {sales_avg_days?.map((item) => {
        if (item.exclude) exclusion = true
        return (
          <Horizontal
            key={item.date}
            justifyContent={'space-between'}
            style={{ backgroundColor: item.highlight ? 'var(--theme-color-2-dim)' : '' }}
          >
            <Texto>{formatters.SHORT_DATE(item.date)}</Texto>
            <Texto>
              {item?.value ? addCommasToNumber(item.value, 0) : 'N/A'}
              {item?.exclude ? '*' : ' '}
            </Texto>
          </Horizontal>
        )
      })}
      {exclusion && (
        <Horizontal justifyContent={'end'} className={'mt-1'}>
          <Texto> * excluded from average</Texto>
        </Horizontal>
      )}
    </>
  )
  const value = sales_avg ? addCommasToNumber(sales_avg, 0) : `-`

  return (
    <Popover trigger={'hover'} content={content} title={<Texto category={'h5'}>4-Week Average</Texto>}>
      <GraviButton
        className={'ghost-gravi-button'}
        style={{ fontWeight: 'normal', textAlign: 'right' }}
        buttonText={value}
      />
    </Popover>
  )
}
